module.exports = __webpack_public_path__ + "static/media/logo_800x800_transparent.405011f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo_800x800_transparent.png
// module id = 428
// module chunks = 0